(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bodenpulse-cart-return"]) return;
  try {
    
  (() => {
    const initialize = async () => {
      const section = document.querySelector('[data-bp-cart-return]');
      if (!section || section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      await customElements.whenDefined('cart-drawer');
      const drawer = document.querySelector('cart-drawer');
      const button = section.querySelector('[data-bp-open-cart]');
      if (!drawer || typeof drawer.open !== 'function') return;
      const open = () => drawer.open(button);
      button.hidden = false;
      button.addEventListener('click', open);
      open();
      window.addEventListener('pageshow', async (event) => {
        if (!event.persisted) return;
        try {
          await drawer.refreshFromServer();
        } finally {
          open();
        }
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bodenpulse-erklaerfilm"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bp-explainer-video')) {
  customElements.define('bp-explainer-video', class extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      if (!button || button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const id = this.dataset.videoId;
        if (!/^[A-Za-z0-9_-]{11}$/.test(id || '')) return;
        const frame = document.createElement('iframe');
        frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1';
        frame.title = this.dataset.title;
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        this.querySelector('.bp-film__player').replaceChildren(frame);
        frame.focus();
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bodenpulse-kontakt"] && !Shopify.designMode) return;
  try {
    
  function prefillProductQuestion() {
    const productName = new URLSearchParams(window.location.search).get('produkt');
    if (!productName || !productName.trim()) return;
    document.querySelectorAll('.bp-contact__form').forEach((form) => {
      const productField = form.querySelector('input[name="contact[Produkt oder Boden]"]');
      const reasonField = form.querySelector('select[name="contact[Anliegen]"]');
      if (productField && !productField.value.trim()) {
        productField.value = productName.trim().slice(0, 500);
      }
      if (reasonField && !reasonField.value) reasonField.value = 'Produktfrage';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prefillProductQuestion, { once: true });
  } else {
    prefillProductQuestion();
  }
  document.addEventListener('shopify:section:load', prefillProductQuestion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.updateStickyMode = this.updateStickyMode.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 989px)');
      this.headerIsAlwaysSticky =
        this.mobileMediaQuery.matches ||
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.updateStickyMode);
      this.headerResizeObserver = new ResizeObserver(this.setHeaderHeight);
      this.headerResizeObserver.observe(this);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
      if (this.header.classList.contains('menu-open')) {
        document.documentElement.style.setProperty('--header-bottom-position', `${Math.max(0, this.getBoundingClientRect().bottom)}px`);
      }
    }

    updateStickyMode() {
      this.headerIsAlwaysSticky = this.mobileMediaQuery.matches ||
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.header.classList.remove('shopify-section-header-hidden', 'scrolled-past-header', 'animate');
      this.header.classList.toggle('shopify-section-header-sticky', this.headerIsAlwaysSticky);
      this.currentScrollTop = Math.max(0, window.scrollY);
      this.setHeaderHeight();
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.updateStickyMode);
      this.headerResizeObserver.disconnect();
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    isNavigationOpen() {
      return this.header.classList.contains('menu-open') ||
        Boolean(this.header.querySelector('header-drawer details[open], header-menu details[open]'));
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.mobileMediaQuery.matches) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden', 'scrolled-past-header', 'animate');
        this.currentScrollTop = Math.max(0, scrollTop);
        return;
      }

      if (this.isNavigationOpen()) {
        this.header.classList.remove('shopify-section-header-hidden');
        this.currentScrollTop = scrollTop;
        this.preventReveal = false;
        return;
      }

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || this.isNavigationOpen()) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky || this.isNavigationOpen()) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  if (!customElements.get('bp-mobile-header-search')) {
    customElements.define('bp-mobile-header-search', class extends HTMLElement {
      connectedCallback() {
        this.header = this.closest('header');
        this.trigger = this.querySelector('button');
        this.search = this.header.querySelector('.bp-search-wrap');
        this.setOpen = open => {
          this.header.classList.toggle('bp-mobile-search-open', open);
          this.trigger.setAttribute('aria-expanded', String(open));
          this.closest('sticky-header')?.setHeaderHeight?.();
          if (open) this.search.querySelector('input[type="search"]')?.focus();
        };
        this.handleToggle = () => this.setOpen(!this.header.classList.contains('bp-mobile-search-open'));
        this.handleKey = event => {
          if (event.key === 'Escape' && this.header.classList.contains('bp-mobile-search-open')) {
            this.setOpen(false);
            this.trigger.focus();
          }
        };
        this.handleOutside = event => {
          if (!this.contains(event.target) && !this.search.contains(event.target)) this.setOpen(false);
        };
        this.trigger.addEventListener('click', this.handleToggle);
        this.header.addEventListener('keydown', this.handleKey);
        document.addEventListener('click', this.handleOutside);
      }
      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.handleToggle);
        this.header?.removeEventListener('keydown', this.handleKey);
        document.removeEventListener('click', this.handleOutside);
      }
    });
  }


  } catch(e) { console.error(e); }
})();
})();
